import React from 'react';
import { KindredIcon } from '../Common/Icons';
import styled from 'styled-components';
import { Description } from './Components';

const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  padding: 1rem 0.5rem;
  padding-bottom: 50vh;
`;
const KeyboardInstallationGuide = () => {
  return (
    <Container>
      <KindredIcon color="purple" />
      <Description />
    </Container>
  );
};

export default KeyboardInstallationGuide;
